export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/DataExportWorker.worker.daa39040.worker.js");
}
